module.exports = __webpack_public_path__ + "static/media/add-activity-clue-card.9d16c46c.svg";